module.exports = __webpack_public_path__ + "img/hr-H-T-1-unload-standup-shadow.486f884c.png";